import { buildProps, definePropType } from '@ll-plus/utils'
import { theme } from 'ant-design-vue'

import ConfigProvider from './config-provider.vue'

import type { ExtractPropTypes } from 'vue'

const componentSize = ['small', 'middle', 'large'] as const

export enum THEME_ENUM {
  'technology-blue' = 'technology-blue',
  'cyan-blue' = 'cyan-blue',
  'dark' = 'dark',
  'gray' = 'gray',
}
// 默认主题风格科技蓝
export const DEFAULT_THEME_MODE = THEME_ENUM['technology-blue']
const { defaultAlgorithm } = theme

export interface ITheme {
  type?: THEME_ENUM // 主题类型
  extraToken?: any // 在type主题下 额外添加的主题属性merge到type下token上
  token?: any // 继承上层 ConfigProvider 中配置的主题。
  inherit?: boolean
  algorithm?: any
  components?: any
}
// props
export const configProviderProps = buildProps({
  // buildProps和defineprops一样
  /**
   * @description 设置为 false 时，移除按钮中 2 个汉字之间的空格
   */
  autoInsertSpaceInButton: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 设置 antd 组件大小
   */
  componentSize: {
    type: String,
    values: componentSize,
  },
  /**
   * @description 设置 antd主题
   */
  theme: {
    type: definePropType<ITheme>(Object),
    default: () => ({
      type: DEFAULT_THEME_MODE,
      extraToken: {},
      inherit: true,
      algorithm: defaultAlgorithm,
    }),
  },
  /**
   * @description 多语言
   */
  locale: {
    type: definePropType<object>(Object),
  },
} as const)

export type ConfigProviderProps = ExtractPropTypes<typeof configProviderProps>

export type ComponentSizeType = ConfigProviderProps['componentSize']
// instance
export type ConfigProviderInstance = InstanceType<typeof ConfigProvider>
